export default __webpack_public_path__ + "static/media/mail.d910c270.svg";